import type { SegmentedControlProps as MantineSegmentedControlProps } from '@mantine/core';
import {
	createStyles,
	// eslint-disable-next-line no-restricted-imports
	SegmentedControl as MantineSegmentedControl,
} from '@mantine/core';

export interface SegmentedControlProps extends MantineSegmentedControlProps {
	w?: string;
	size?: string;
}

const useStyles = createStyles((theme) => ({
	label: {
		paddingTop: theme.spacing['2xs'],
		paddingBottom: theme.spacing['2xs'],
		paddingLeft: theme.spacing.sm,
		paddingRight: theme.spacing.sm,
		fontSize: theme.fontSizes.xs,
		color: theme.other.getColor('text/secondary/default'),
	},
	root: {
		padding: 0,
		backgroundColor: theme.other.getColor('fill/tertiary/default'),
		color: theme.other.getColor('icon/chart/1'),
	},
	indicator: {
		// This is the only way to make it work with root padding 0
		top: theme.spacing['3xs'],
		left: theme.spacing['3xs'],
		border: `1px solid ${theme.other.getColor('border/tertiary/default')}`,
	},
}));

function SegmentedControl({
	data,
	w,
	value,
	onChange,
	size,
}: SegmentedControlProps): JSX.Element {
	const { theme, classes } = useStyles();
	return (
		<MantineSegmentedControl
			classNames={{
				label: classes.label,
				root: classes.root,
				indicator: classes.indicator,
			}}
			data={data}
			w={w}
			value={value}
			onChange={onChange}
			size={size}
			radius="sm"
		/>
	);
}

export { SegmentedControl };
